import React, { FC, Fragment } from 'react'
import { HeaderNotice } from '@/network/graphql.g'
import HeaderPromoCustomize from '@/components/molecules/headerPromo/headerPromoCustomize'
import { useAsset } from '@/providers/assetsProvider'
import HeaderPromoDefault from '@/components/molecules/headerPromo/headerPromoDefault'

type HeaderPromoProps = {
  headerNotice: HeaderNotice
  showHeaderPromo: boolean
  setShowHeaderPromo: React.Dispatch<React.SetStateAction<boolean>>
}

const HeaderPromo: FC<HeaderPromoProps> = ({
  headerNotice,
  showHeaderPromo,
  setShowHeaderPromo
}) => {
  const { isCartProcessStep } = useAsset()
  const hasNoticeText = !!headerNotice?.text?.length

  const shouldDisplayCustomPromo =
    hasNoticeText && showHeaderPromo && !isCartProcessStep

  const shouldDisplayDefaultPromo =
    !shouldDisplayCustomPromo || isCartProcessStep

  return (
    <Fragment>
      {shouldDisplayCustomPromo && (
        <HeaderPromoCustomize
          headerNotice={headerNotice}
          setShowHeaderPromo={setShowHeaderPromo}
        />
      )}
      {shouldDisplayDefaultPromo && (
        <HeaderPromoDefault
          display={{
            tablet: 'flex',
            desktop: 'flex',
            mobile: isCartProcessStep ? 'flex' : 'none'
          }}
        />
      )}
    </Fragment>
  )
}

export default HeaderPromo
